import React, { useEffect } from 'react';
import clsx from 'clsx';
import Lottie from 'react-lottie-wrapper';
import animationData from '@lmt/unicorn-shared/app/animations/submit-load.json';
import styles from './SubmitButton.module.scss';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export interface SubmitButtonProps {
  title: string;
  className?: string;
  submitting: boolean;
  disabled?: boolean;
  testId?: string;
  onClick?: () => void;
  openCalendarTab?: () => void;
  isCancel?: boolean;
}

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = (
  props,
) => {
  useEffect(() => {
    if (props.submitting && props.isCancel && props.openCalendarTab) {
      props.openCalendarTab();
    }
  }, [props.submitting, props.isCancel, props.openCalendarTab]);

  return (
    <button
      type="submit"
      disabled={props.disabled || props.submitting}
      className={clsx(styles.submitButton, props.className, {
        [styles.loading]: props.submitting,
      })}
      data-test-id={props.testId}
      onClick={props.onClick}
    >
      <span className={styles.title}>{props.title}</span>
      {props.submitting && (
        <span className={styles.lottie} data-test-id="loading">
          <Lottie options={defaultOptions} height={'unset'} width={60} />
        </span>
      )}
    </button>
  );
};
